import React, {
  useEffect, useState,
} from 'react';

import { withCssModulesClassNames } from '../../common/nextMigrationHelpers';
import { default as styles } from '../../scss/components/CountdownTimer.module.scss';

const withCssModulesClassNamesHandler = withCssModulesClassNames(styles);

const CountdownTimer = ({
  copy = '',
  header,
  stretched = true,
  countdownTarget,
}) => {
  useEffect(() => {
    update();
    const interval = setInterval(update, 100);
    return () => {
      clearInterval(interval);
    };
  }, []);
  const [time, setTime] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const getTimeLeft = (countdownTarget) => {
    const target = new Date(countdownTarget);
    const date = new Date();

    let rest = target - date;
    if (rest < 0) rest = 0;
    const days = Math.floor(rest / (24 * 60 * 60 * 1000));
    rest %= (24 * 60 * 60 * 1000);
    const hours = Math.floor(rest / (60 * 60 * 1000));
    rest %= (60 * 60 * 1000);
    const minutes = Math.floor(rest / (60 * 1000));
    rest %= (60 * 1000);
    const seconds = Math.floor(rest / (1000));

    return {
      days,
      hours,
      minutes,
      seconds,
    };
  };

  const update = () => {
    const timeLeft = getTimeLeft(countdownTarget);

    if (timeLeft.seconds !== time.seconds) { // optimizing renders count
      setTime(timeLeft);
    }
  };

  const renderCounter = (title, value, withDelimiter) => {
    const counterDigits = `${value < 10 ? `0${value}` : value}`.split('');
    return (
      <>
        <span className={withCssModulesClassNamesHandler('countdown-timer__counter')}>
          <span className={withCssModulesClassNamesHandler('countdown-timer__counter-number')}>
            {counterDigits.map((digit, index) => (
              <span key={`${index}-${digit}`} className={withCssModulesClassNamesHandler('countdown-timer__counter-digit')}>{digit}</span>
            ))}
          </span>
          <span className={withCssModulesClassNamesHandler('countdown-timer__counter-title-wrapper')}>
            <span className={withCssModulesClassNamesHandler('countdown-timer__counter-title')}>{title}</span>
          </span>
        </span>
        {withDelimiter && <span className={withCssModulesClassNamesHandler('countdown-timer__delimiter')} />}
      </>
    );
  };

  const renderTimer = (inline) => {
    const {
      days,
      hours,
      minutes,
      seconds,
    } = time;
    return (
      <div
        className={withCssModulesClassNamesHandler('countdown-timer', {
          'countdown-timer--narrow': !stretched,
          'countdown-timer--wide': stretched,
          'countdown-timer--inline': inline,
        })}
      >
        {header && <div className={withCssModulesClassNamesHandler('countdown-timer__header')}>{header}</div>}
        <div className={withCssModulesClassNamesHandler('countdown-timer__timer')}>
          {renderCounter('days', days, true)}
          {renderCounter(stretched ? 'hours' : 'hrs', hours, true)}
          {renderCounter(stretched ? 'minutes' : 'min', minutes, true)}
          {renderCounter(stretched ? 'seconds' : 'sec', seconds)}
        </div>
      </div>
    );
  };
  if (copy) {
    const [
      preCopy,
      postCopy,
    ] = copy.split('$countdown');
    return (
      <>
        {preCopy}
        {renderTimer(true)}
        {postCopy}
      </>
    );
  }
  return renderTimer();
};

export default CountdownTimer;
